import { get, post, patch, put } from '../Http';

export function approveTimesheet(timesheetId, body) {
  const URL = `/timesheets/${timesheetId}/approve_timesheets`;
  return post(URL, body);
}

export function assignPaymentAndShortlistToJob(jobId, body) {
  const URL = `/jobs/${jobId}/shortlists`;
  return post(URL, body);
}

export function successApproveTimesheet(timesheetId) {
  const URL = `/timesheets/${timesheetId}/approve_timesheets`;
  window.location.href = URL;
}

export function createJob(body) {
  const URL = '/jobs';
  return post(URL, body);
}

export function createRehireJob(body, onErrorResponse) {
  const URL = '/rehire_jobs';

  return post(URL, body, onErrorResponse);
}

export function createProfileHireJob(body) {
  const URL = '/profile_hire_jobs';

  return post(URL, body);
}

export function updateJob(body, jobId) {
  const URL = `/jobs/${jobId}`;
  return patch(URL, body);
}

export function createOrUpdateJob(body, jobId) {
  if (jobId) {
    return updateJob(body, jobId);
  }
  return createJob(body);
}

export function fetchCategories() {
  const URL = '/api/v1/job-categories';
  const formatResponse = response => response.data
    .filter(category => (category.relationships.skills.data.length > 0))
    .map(category => ({
      id: category.id,
      name: category.attributes.name,
    }));
  return get(URL).then(formatResponse);
}

export function fetchLocations() {
  const URL = '/locations';
  return get(URL);
}

export function fetchPaymentTerms() {
  const URL = '/payment_terms';
  return get(URL);
}

export function fetchPreviouslyHired(locationId, skillId, startTime, finishTime) {
  const URL = `/previously_hired_weployees?location_id=${locationId}&skill_id=${skillId}&start_time=${startTime}&finish_time=${finishTime}`;
  return get(URL);
}

export function fetchShortlistedWeployees(jobId) {
  const URL = `/jobs/${jobId}/shortlist_weployees`;
  return () => get(URL);
}

export function fetchRehireWeployees(jobId) {
  const URL = `/jobs/${jobId}/rehire_shortlist_weployees`;
  return () => get(URL);
}

export function fetchSkills(jobCategoryId) {
  const URL = `/api/v1/skills?filter[job-category-id]=${jobCategoryId}`;
  const formatResponse = response => response.data.map(skill => ({
    description: skill.attributes.description,
    id: skill.id,
    imgSrc: skill.attributes.icon.url,
    name: skill.attributes.name,
  }));
  return get(URL).then(formatResponse);
}

export function fetchWeployeePreviews(locationId, skillId) {
  const URL = `/weployee_previews?location_id=${locationId}`;
  return get(skillId ? URL.concat(`&skill_id=${skillId}`) : URL);
}

export function successCreateJobOnInstant(jobId) {
  const URL = `/jobs/${jobId}/process_payments/new`;
  return URL;
}

export function createCreditApprovalPayment(jobId, body) {
  const URL = `/jobs/${jobId}/credit_approvals`;
  return post(URL, body);
}

export function createCreditCardPayment(jobId, body) {
  const URL = `/jobs/${jobId}/credit_cards`;
  return post(URL, body);
}

export function successJobPublished(jobId) {
  const URL = `/jobs/${jobId}/publishings`;
  return URL;
}

export function successSelectJobPublished(jobId) {
  const URL = `/jobs/${jobId}/shortlists/new`;
  return URL;
}

export function getSuccessRehireJobPublishedPath(jobId) {
  const URL = `/jobs/${jobId}/rehire_shortlists/new`;
  return URL;
}

export function successJobFilled(jobId) {
  const URL = `/jobs/${jobId}/shortlists`;
  return URL;
}

export function updatePayment(body) {
  const URL = '/payments';
  return put(URL, body);
}

export function successUpdatePayment() {
  const URL = '/payments/edit';
  return URL;
}

export function createExtensionRequests(body, jobId) {
  const URL = `/jobs/${jobId}/extension_requests`;
  return post(URL, body);
}

export function rejectTimesheet(timesheetId, body) {
  const URL = `/timesheets/${timesheetId}`;
  return patch(URL, body);
}

export default {
  approveTimesheet,
  assignPaymentAndShortlistToJob,
  createCreditApprovalPayment,
  createCreditCardPayment,
  createExtensionRequests,
  createJob,
  createOrUpdateJob,
  fetchCategories,
  fetchLocations,
  fetchPaymentTerms,
  fetchPreviouslyHired,
  fetchSkills,
  fetchWeployeePreviews,
  fetchRehireWeployees,
  successApproveTimesheet,
  successCreateJobOnInstant,
  successJobFilled,
  successJobPublished,
  successSelectJobPublished,
  successUpdatePayment,
  updatePayment,
};
